import { render, staticRenderFns } from "./InstructorPage.vue?vue&type=template&id=9a46149a&"
import script from "./InstructorPage.vue?vue&type=script&lang=js&"
export * from "./InstructorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InstructorPage.vue"
export default component.exports